/**
 * Line-clamp is similar to `text-overflow: ellipsis` except that it works over
 * multiline text. It's not well-supported yet, and requires very specific
 * properties to work in browsers that do support it.
 *
 * https://css-tricks.com/almanac/properties/l/line-clamp/
 */
export default function lineClamp(lines: number) {
  return `
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `;
}
